package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.entity.DriverEnterprise
import com.milta.feature.profile.domain.repository.DriverEnterprisesRepository

class GetMyEnterprisesUseCase(private val repository: DriverEnterprisesRepository) {
    suspend operator fun invoke(): Result<List<DriverEnterprise>> = repository.getMyEnterprises()
}
